import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal
} from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

export interface VerticalTab {
  name: string;
  icon: string;
  routerLink: string;
}

@Component({
  selector: 'app-vertical-tabs',
  imports: [NgClass, RouterLink, RouterLinkActive],
  templateUrl: './vertical-tabs.component.html',
  styleUrl: './vertical-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerticalTabsComponent {
  name: InputSignal<string> = input<string>('');
  tabs: InputSignal<VerticalTab[]> = input<VerticalTab[]>([]);
}
